module.exports = __webpack_public_path__ + "media/customizations/ontopoftheworld/back-06bc7a57f6d17a5e62573a24c67e8c91.jpg";